<template>
  <section id="faq-section">
    <div class="vcore_container pe_container footer_margins">
      <div id="faq-title">
        <h2 class="question-header">Have a question?</h2>
      </div>
      <div id="faq-main">
        <p>
          Have a specific question about financing? We have answers. Check out
          our
          <a href="#" class="faq-link" @click="faqBtnClick">FAQ section </a>for
          additional information. <br /><br />
          For questions regarding your account, call <b>855-893-1292</b>.
        </p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "HaveAQuestion",
  components: {},
  methods: {
    faqBtnClick() {
      window.location =
        "https://www.commercebank.com/personal/borrow/health-services-financing/faqs";
    },
  },
};
</script>

<style lang="scss" scoped>
#faq-section {
  width: 100%;
  height: auto;
  align-content: left;
  background-color: #007ea8;
  color: white;
  margin: 30px 0;
  padding: 50 50 25 50;
  margin: 0px;

  @media (max-width: $grid-breakpoint-xl) {
    padding-bottom: 30px;
  }

  @media (max-width: $grid-breakpoint-md) {
    color: white;
    margin: 0px;
    padding-top: 40px;
  }
}

.footer_margins {
  margin: 0px 10vh;

  @media (max-width: $grid-breakpoint-lg) {
    margin: 0px 3vh;
  }

  @media (max-width: $grid-breakpoint-md) {
    margin: 0px 2vh;
  }
}

.question-header {
  font-size: 24px;
  font-weight: 600;
}

.faq-link {
  color: #fff;
  text-decoration: underline;
  cursor: pointer;
}

#faq-title {
  font-weight: bold;
  height: 44px;
  width: 596px;
  color: #ffffff;
  font-family: "Open Sans";
  font-size: 31px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 44px;
  padding-top: 54px;

  @media (max-width: $grid-breakpoint-md) {
    padding: 0 0 0 0;
    width: 100%;
    font-size: 22px;
  }
}

#faq-main {
  padding-bottom: 31px;

  > p {
    height: 145px;
    width: 100%;
    color: #ffffff;
    font-family: "Open Sans";
    font-size: 18px;
    letter-spacing: 0;
    line-height: 29px;
    padding-top: 54px;

    @media (max-width: $grid-breakpoint-md) {
      padding: 0 0 0 0;
      width: 100%;
      font-size: 15px;
    }
  }

  button {
    background-color: white;
    border-color: white;
    color: #007ea8;
    display: inline-block;
    width: 409px;
    height: 56px;

    p {
      height: 100%px;
      width: 100%;
      color: #007ea8;
      font-family: "Open Sans";
      font-size: 20px;
      font-weight: bold;
      letter-spacing: 0;
      line-height: 17px;
      text-align: center;
    }

    @media (max-width: $grid-breakpoint-sm) {
      margin-top: 30px;
      width: 100%;
      height: 30;
      font-size: 14px;
    }
  }
}
</style>
